import {FeaturedRouteType} from "@SearchResults/features/featuredRoutes/types/FeaturedRoute.type";
import RouteType from "@Route/types/Route.type";

export default function isFeaturedRoute(route: RouteType, featuredRoutes: FeaturedRouteType[]): boolean {
    return featuredRoutes.some((featuredRoute) => {
        return featuredRoute.singleCompanyId === parseInt(route.companyId, 10)
            && featuredRoute.singleDepartureStationTime === route.travelInfo.departureStation.departureTime
            && featuredRoute.singleDestinationStationTime === route.travelInfo.destinationStation.arrivalTime;
    });
}